import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import css from 'styles/components/checkout/caap/sectionTitle.scss';

const SectionTitle = (params, { testId }) => {
  const {
    active,
    linkText = 'Close',
    linkTo,
    onLinkClick,
    showLink,
    showTitleBar,
    stepNumber,
    title
  } = params;

  if (!showTitleBar) {
    return null;
  }

  const wrapperStyles = cn({
    [css.active]: active,
    [css.inactive]: !active
  });

  const linkContainerStyes = cn({
    [css.closeButtonContainer]: linkText === 'Close',
    [css.viewButtonContainer]: linkText !== 'Close'
  });

  return (
    <Row desktopOnly={true}>
      <div className={wrapperStyles}>
        <Row>
          <RowSpan span="12">
            <div className={css.titleWrapper}>
              <div className={css.stepIndex}>
                <h3>{stepNumber}</h3>
              </div>
              <h4 className={css.title}>{title}</h4>
              {
                showLink && <div className={linkContainerStyes}>
                  <Link
                    onClick={onLinkClick}
                    to={linkTo}
                    data-test-id={testId('linkSection')}>{linkText}</Link>
                </div>
              }
            </div>
          </RowSpan>
        </Row>
      </div>
    </Row>
  );
};

SectionTitle.contextTypes = {
  testId: PropTypes.func
};

export default SectionTitle;
